import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { mockData } from '../mock';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-24 px-4 bg-gray-50 dark:bg-slate-900 transition-colors duration-300">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-purple-100 dark:bg-purple-900/50 rounded-full mb-6 border dark:border-purple-700">
            <HelpCircle className="w-5 h-5 text-purple-600 dark:text-purple-400" />
            <span className="text-sm font-semibold text-purple-700 dark:text-purple-300">Merak Edilenler</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
            <span className="gradient-text-neon">Sıkça Sorulan Sorular</span>
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            Aklınıza takılan soruların cevaplarını burada bulabilirsiniz.
          </p>
        </div>

        <div className="space-y-4">
          {mockData.faqs.map((faq, index) => (
            <div
              key={index}
              className="group bg-white dark:bg-slate-800 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border dark:border-slate-700"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between group-hover:bg-purple-50/50 dark:group-hover:bg-purple-900/20 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="text-lg font-bold text-gray-900 dark:text-white pr-8">
                  {faq.question}
                </span>
                <div className={`p-2 rounded-full bg-purple-100 dark:bg-purple-900/50 text-purple-600 dark:text-purple-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <ChevronDown className="w-5 h-5" />
                </div>
              </button>
              
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-6 pt-2 text-gray-600 dark:text-gray-400 leading-relaxed text-base border-t border-purple-50 dark:border-slate-700">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
